import React, { useCallback, useState } from 'react'
import { BsFillTrashFill, BsThreeDotsVertical } from 'react-icons/bs'
import { FiEdit3 } from 'react-icons/fi'
import useApi from '../../hooks/useApi'
import Modal from '../../Korbantech/components/Modal'
import { Onboarding } from '../../types/Onboarding'
import { ContextMenu } from '../ContextMenu'
import { NewOnboarding } from './NewOnboarding'

export const OnboardingCard = ({ item }: Props) => {

    const [contextIsOpen, setContextIsOpen] = useState<boolean>()
    const [modalOpen, setModalOpen] = useState<boolean>(false)
    const [modalDeleteOpen, setModalDeleteOpen] = useState<boolean>(false)

    const api = useApi()

    const handleDelete = useCallback(async () => {
        await api.delete(`/admin/onboarding/${item.id}`).then(res => {
            window.location.reload();
        }).catch(console.log)
    }, [item, api])

    return (
        <div className='bg-white'>
            {item.banner && <img src={item.banner} alt={item.title} />}
            <div className='p-1'>
                {item.title &&
                    <div className='flex justify-between'>
                        <div className='text-lg font-semibold'>{item.title}</div>
                        <div>
                            <BsThreeDotsVertical className='text-lg' onClick={() => setContextIsOpen(true)} />
                            <div className='relative'>
                                <ContextMenu open={contextIsOpen} close={() => setContextIsOpen(false)}>
                                    <div className='flex items-center cursor-pointer' onClick={() => setModalOpen(true)}>
                                        <FiEdit3 className='mr-1' />Editar
                                    </div>
                                    <div className='flex items-center cursor-pointer' onClick={() => setModalDeleteOpen(true)}>
                                        <BsFillTrashFill className='mr-1 text-red-500' />Deletar</div>
                                </ContextMenu>
                            </div>
                        </div>
                    </div>
                }
                {item.description &&
                    <div className='text-gray-600 text-sm'>
                        {item.description.slice(0, 120)}
                    </div>
                }
            </div>
            <Modal open={modalOpen} onClickCloseButton={() => setModalOpen(false)}>
                <NewOnboarding onboarding={item} />
            </Modal>
            <Modal open={modalDeleteOpen} onClickCloseButton={() => setModalDeleteOpen(false)}>
                <strong>Realmente deseja deletar:</strong> <br />
                Slide: {item.title} da posição {item.step} <br />
                <div className='grid grid-cols-2 gap-x-3 mt-2'>
                    <button className='py-1 px-4 text-center rounded-md bg-primary' onClick={() => setModalDeleteOpen(false)}>Cancelar</button>
                    <button className='py-1 px-4 text-center rounded-md text-white bg-red-500' onClick={handleDelete}>Confirmar e deletar</button>
                </div>
            </Modal>
        </div>
    )
}

interface Props {
    item: Onboarding
}